// extracted by mini-css-extract-plugin
export default {"pageWrapper":"BorrowPage-module__pageWrapper--cGc_P"};